import Auth from '../../../lib/Core/Backend/Controllers/Auth';
import Notify from 'lib/Utils/Alert';
import React, { useEffect, useRef, useState } from 'react';
import ReactNotificationAlert from 'react-notification-alert';
import Select from 'react-select';
import { Col, CustomInput, FormGroup, Label, Row,Modal, ModalBody, ModalFooter, ModalHeader ,Button} from 'reactstrap';
import Purchaser from '../../../lib/Core/Backend/Controllers/Purchaser';

const PurchaserUsersManager = ({activeOp, contactSelect, purchaserId, setContact, token, apiUser, setApiUser, permissions, setPermissions,numberOfContact,setNumberOfContact}) => {const purchaserCtl = new Purchaser(token);
  const authCtl = new Auth(token);

  const [contacts, setContacts] = useState([]);
 const [loading, setLoading] = useState(true);
    const [confirmMessage,setConfirmMessage] = useState(false)
    const toggleConfirmmessage = () => setConfirmMessage(!confirmMessage)

  const handleApiUserChange = (e) => {
    setApiUser(e.target.checked);
  };

  const handlePermissionsChange = (e) => {
    setPermissions(e.target.checked);
  };

  const selectChange = (e) => {
    setContact(e)
  }

  const alert = useRef();
  useEffect(()=>{
    if(activeOp === 'Add new'){
      purchaserCtl.contacts(purchaserId, (data) => {
        if(data && !data.error){
          let availableContacts = [];
          let idx = 0;
          const checkContacts = (contacts) => {
            if(!!contacts[idx]){
              authCtl.checkIfUserExists(contacts[idx].email, verificationData => {
                if(!verificationData.valueOf())
                  availableContacts.push({...contacts[idx], value: contacts[idx].id, label: `${contacts[idx].contactFirstName} ${contacts[idx].contactLastName}`})
                idx++;
                if(idx === data.length){
                  setContacts(availableContacts);
                 
                  
                  setNumberOfContact(data)
                  setLoading(false);
                }
                checkContacts(data);
                
                
              });
            } else {
              return;
            }
          };
          checkContacts(data);
        } else {
          Notify(alert, 'danger', data.errorMessage ?? data.error);
        }
      });
    }
    
  },[])

  useEffect(()=>{
if(loading === false && contacts.length === 0){
  toggleConfirmmessage()
}
  },[loading])
  
  return (
    <>
      <ReactNotificationAlert ref={alert}/>
      {activeOp === 'Add new' &&
        <Row form className="justify-content-center">
          <Col md={8}>
            <FormGroup>
              <Label for="email">Select a contact</Label>
              <Select id="purchaseFormCardType"
                ref={contactSelect}
                options={contacts}
                menuPortalTarget={document.body} 
                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                onChange={selectChange}
                isLoading={loading}
              />
            </FormGroup>
          </Col>
        </Row>
      }
      <FormGroup className="justify-content-center mx-3 mt-4 ">
        <Row style={activeOp !== 'Edit' ? { display: 'none' } : {} }>
          <Col className="col">
              <Label for="active">Is user active?</Label>
          </Col>
           <Col className="col">
            <FormGroup>
              <CustomInput id="active" name="active" type="switch" label="Active User"/>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col className="col">
              <Label for="active">Can the user use the API?</Label>
          </Col>
          <Col className="col">
            <FormGroup>
              <CustomInput id="apiUser" name="apiUser" type="switch" label="API user" checked={apiUser}
              onChange={handleApiUserChange} />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col className="col">
              <Label for="permissions">Is user able to manage other users?</Label>
          </Col>
          <Col className="col">
            <FormGroup>
              <CustomInput id="permissions" name="permissions" type="switch" label="Manage users"   checked={permissions}
               onChange={handlePermissionsChange}/>
            </FormGroup>
          </Col>
        </Row>
      </FormGroup>
      <Modal isOpen={confirmMessage} toggle={toggleConfirmmessage} backdrop="static" centered size="md">
      <ModalHeader toggle={toggleConfirmmessage} className="custom_header_colourTwo">
        Contact Alert
      </ModalHeader>
      <ModalBody>
        <p style={{fontWeight:"400"}}>Currently does not have any contact</p>
        Add a contact within the same flow, then create a user.
      </ModalBody>
      <ModalFooter>
        <Button type="button" color="secondary" onClick={toggleConfirmmessage}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
    </>
  );
}
 
export default PurchaserUsersManager;